export default __webpack_public_path__ + "static/media/trackorder.a1549641.jpg";